module.exports = __webpack_public_path__ + "media/images/logo/ekuitas-white-a3a170b6a0141b7e136d17cc179b2b40.svg";